import { View } from '@shared/components/View';
import styles from './Pagination.module.css';

interface PaginationProps {
  length: number;
  activeIndex: number;
  onClick: (index: number) => void;
}

export function Pagination({ length, activeIndex, onClick: onClick }: PaginationProps) {
  return (
    <View className={styles.pagination}>
      {Array(length)
        .fill(undefined)
        .map((_, index) => (
          <PaginationDot
            key={index}
            index={index}
            active={index === activeIndex}
            onClick={onClick}
          />
        ))}
    </View>
  );
}

interface PaginationDotProps {
  index: number;
  active: boolean;
  onClick: (index: number) => void;
}

function PaginationDot({ active, index, onClick }: PaginationDotProps) {
  return (
    <button
      type="button"
      disabled={active}
      className={styles.dotButton}
      onClick={() => onClick?.(index)}
    >
      <span className={styles.dot} />
    </button>
  );
}
